'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var hamtShardedDirectoryContent = function hamtShardedDirectoryContent(cid, node, unixfs, path, resolve, depth, ipld) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return listDirectory(node, path, resolve, depth, ipld, options);
  };
};

function listDirectory(_x, _x2, _x3, _x4, _x5, _x6) {
  return _listDirectory.apply(this, arguments);
}

function _listDirectory() {
  _listDirectory = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node, path, resolve, depth, ipld, options) {
    var links, _iterator2, _step2, link, name, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, file;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            links = node.Links;
            _iterator2 = _createForOfIteratorHelper(links);
            _context.prev = 2;

            _iterator2.s();

          case 4:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 54;
              break;
            }

            link = _step2.value;
            name = link.Name.substring(2);

            if (!name) {
              _context.next = 15;
              break;
            }

            _context.next = 10;
            return _awaitAsyncGenerator(resolve(link.Hash, name, "".concat(path, "/").concat(name), [], depth + 1, ipld));

          case 10:
            result = _context.sent;
            _context.next = 13;
            return result.entry;

          case 13:
            _context.next = 52;
            break;

          case 15:
            _context.next = 17;
            return _awaitAsyncGenerator(ipld.get(link.Hash));

          case 17:
            node = _context.sent;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 20;
            _iterator = _asyncIterator(listDirectory(node, path, resolve, depth, ipld, options));

          case 22:
            _context.next = 24;
            return _awaitAsyncGenerator(_iterator.next());

          case 24:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 28;
            return _awaitAsyncGenerator(_step.value);

          case 28:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 36;
              break;
            }

            file = _value;
            _context.next = 33;
            return file;

          case 33:
            _iteratorNormalCompletion = true;
            _context.next = 22;
            break;

          case 36:
            _context.next = 42;
            break;

          case 38:
            _context.prev = 38;
            _context.t0 = _context["catch"](20);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 42:
            _context.prev = 42;
            _context.prev = 43;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 47;
              break;
            }

            _context.next = 47;
            return _awaitAsyncGenerator(_iterator.return());

          case 47:
            _context.prev = 47;

            if (!_didIteratorError) {
              _context.next = 50;
              break;
            }

            throw _iteratorError;

          case 50:
            return _context.finish(47);

          case 51:
            return _context.finish(42);

          case 52:
            _context.next = 4;
            break;

          case 54:
            _context.next = 59;
            break;

          case 56:
            _context.prev = 56;
            _context.t1 = _context["catch"](2);

            _iterator2.e(_context.t1);

          case 59:
            _context.prev = 59;

            _iterator2.f();

            return _context.finish(59);

          case 62:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 56, 59, 62], [20, 38, 42, 52], [43,, 47, 51]]);
  }));
  return _listDirectory.apply(this, arguments);
}

module.exports = hamtShardedDirectoryContent;